import React, {memo} from 'react'

import {FormMapUI} from './FormMapUI/FormMapUI'
import {useFormMap} from './hooks'
import {Props} from './types'

export const OrderMap = memo<Props>(function OrderMap({dir, lang = 'ru_RU', location}) {
  const {
    isDragPointAllowed,
    isRouteVisible,
    fetchTaxiSuggestHandler,
    orderPointsCoordinates,
    mapLocationResult,
    routePointCoordinates,
    sourcePointCoordinates,
  } = useFormMap({location})

  return (
    <FormMapUI
      dir={dir}
      isDragPointAllowed={isDragPointAllowed}
      isRouteVisible={isRouteVisible}
      lang={lang}
      location={location}
      mapLocationResult={mapLocationResult}
      onPlacemarkChange={fetchTaxiSuggestHandler}
      orderPointsCoordinates={orderPointsCoordinates}
      routePointCoordinates={routePointCoordinates}
      sourcePointCoordinates={sourcePointCoordinates}
    />
  )
})
